"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeaderCell = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var icons_1 = require("../../icons");
var Text_1 = require("../Text");
var Icon_1 = require("../Icon");
var themes_1 = require("../../themes");
var Cell_1 = require("../Cell");
var styles_1 = __importDefault(require("./styles"));
var TableHeaderCell = function (_a) {
    var title = _a.title, sortable = _a.sortable, filterable = _a.filterable, _b = _a.onSort, onSort = _b === void 0 ? function () { } : _b, _c = _a.defaultSortOrder, defaultSortOrder = _c === void 0 ? 'asc' : _c, _d = _a.width, width = _d === void 0 ? 'auto' : _d, minWidth = _a.minWidth, _e = _a.role, role = _e === void 0 ? 'cell' : _e, rest = __rest(_a, ["title", "sortable", "filterable", "onSort", "defaultSortOrder", "width", "minWidth", "role"]);
    var _f = (0, react_1.useState)(defaultSortOrder), sortDirection = _f[0], setSortDirection = _f[1];
    var classes = (0, styles_1.default)({ width: width, minWidth: minWidth });
    var handleChange = function () {
        if (sortDirection === 'asc') {
            setSortDirection('desc');
        }
        else {
            setSortDirection('asc');
        }
        onSort(sortDirection);
    };
    return ((0, jsx_runtime_1.jsx)(Cell_1.Cell, __assign({ "data-testid": "column-header", role: "columnheader", className: classes[role] }, rest, { width: width }, { children: (0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between", component: "button", className: classes.button, onClick: sortable ? function () { return handleChange(); } : function () { }, "data-testid": "sort-button" }, { children: [(0, jsx_runtime_1.jsxs)(Text_1.Text, __assign({ display: "flex", justifyContent: "space-between", component: "h6", size: "small", weight: "semi-bold", color: themes_1.materialColors.grey[500], style: { textTransform: 'uppercase' } }, { children: [rest.children, sortable ? ((0, jsx_runtime_1.jsx)(Icon_1.Icon, __assign({ className: classes.filter, isSelected: true, simple: true, size: "small", "data-testid": "arrow" }, { children: sortDirection === 'asc' ? (0, jsx_runtime_1.jsx)(icons_1.ArrowDown, {}) : (0, jsx_runtime_1.jsx)(icons_1.ArrowUp, {}) }))) : null] })), filterable ? ((0, jsx_runtime_1.jsx)(Icon_1.Icon, __assign({ isSelected: true, simple: true, size: "small", "data-testid": "filter" }, { children: (0, jsx_runtime_1.jsx)(icons_1.Filter, {}) }))) : null] })) })));
};
exports.TableHeaderCell = TableHeaderCell;
